import { isComponentFor } from "Shared/resolve-component";
export const isProductPage = (currentPage) => {
    return (isComponentFor(currentPage.componentName, "Avensia.Shop.Features.Product.Commerce.ProductViewModel"));
};
